import { Action } from 'react-fetching-library';
import { ItemList } from '../../types';

export const getItemList: Action<ItemList> = {
    method: 'GET',
    endpoint: '/list.json'
}